<template>
    <transition name="fade">
        <div id="drag-n-drop-relaunch">
            <transition name="fade">
            <div v-show="dropState">
                <div class="drop-zone" id="drop-zone-computer" @dragleave="OnDragLeave($event)" @dragenter="OnDragEnter($event, '#f6b93b')" draggable="false" @dragover="OnDragOver($event)" @drop="OnDrop(3)"></div>

                <div class="drop-zone" id="drop-zone-desk" @dragleave="OnDragLeave($event)" @dragenter="OnDragEnter($event, '#1e3799')" draggable="false" @dragover="OnDragOver($event)" @drop="OnDrop(105.25)"></div>
            </div>
            </transition>

            <div @dragstart="OnDragStart" @dragend="OnDragEnd" draggable="true" id="drag-element"></div>

        </div>
    </transition>
</template>
<script>
    export default {
        name: 'DragNDropRelaunch',
        data() {
            return {
                dropState: false
            }
        },
        methods: {
            OnDragStart() {
                document.querySelector('#drag-element').style.opacity = "0.3"
                this.dropState = true
            },
            OnDragEnd() {
                document.querySelector('#drag-element').style.opacity = "1"
                this.dropState = false
            },
            OnDrop(time) {
                this.$parent.video.currentTime = time;
                this.$parent.video.play()
                this.$parent.video.playbackRate = 1
            },
            OnDragOver($event) {
                $event.preventDefault()
            },
            OnDragEnter($event, hexa) {
                document.querySelector("#" + $event.target.id).style.backgroundColor = hexa
            },
            OnDragLeave($event) {
                document.querySelector("#" + $event.target.id).style.backgroundColor = "transparent"
            }
        }
    }
</script>
<style lang="scss" scoped>
    #drag-n-drop-relaunch {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        .drop-zone {
            border-radius: 100%;
            position: absolute;
            cursor: not-allowed;
            transition: 0.2s;

            &#drop-zone-desk {
                width: 5%;
                height: 9%;
                bottom: 10%;
                right: 15%;
                border: 3px solid #1e3799;
            }

            &#drop-zone-computer {
                width: 9%;
                height: 10%;
                bottom: 9%;
                left: 28%;
                border: 3px solid #f6b93b;

            }

        }

        #drag-element {
            border-radius: 100%;
            cursor: grab;
            position: absolute;
            width: 8%;
            height: 14%;
            bottom: 22%;
            right: 34%;
            border: 3px solid #eb2f06;
            transition: 1s;
            &:hover {
                transition: 0.2s;
                background-color: #eb2f06;
            }

        }
    }

</style>
